<template>
  <div class="navbar-collapse">
    <ul class="navbar-nav me-auto w-100">
      <li>
        <div class="profile" v-if="$auth.user">
          <div class="detail-cls-lnk">
            <h5 class="mb-2">{{ $t('Welcome', { msg: $auth.user.user_name }) }}!</h5>
            <p>{{ $auth.user.mobile_number }}</p>
          </div>
          <div class="edit-cls-lnk">
            <router-link v-if="$auth.user" to="/profile" v-slot="{ href, navigate, isActive }">
      <li class="text-end d-flex flex-column" :class="[isActive ? 'nav-item active' : 'nav-item']"
        data-bs-dismiss="offcanvas">
        <button
          class="navbar-toggler navbar-toggler-right close-btn border-0 d-inline-flex d-sm-none ms-auto mb-sm-0 mb-3"
          type="button" data-bs-dismiss="offcanvas" aria-label="Close"><span><i class="fas fa-times"></i></span></button>
        <a class="nav-link" :href="href" @click="navigate">{{ $t('My profile') }}</a>
      </li>
      </router-link>
  </div>
  </div>
  <div class="guest align-items-center" v-if="!$auth.user">
    <div class="guest-cls">
      <h6>{{ $t('Welcome Guest') }} !</h6>
    </div>
    <div class="login-cls-lnk">
      <!-- <router-link v-if="!$auth.user" to="/sign-in" v-slot="{ href, navigate, isActive }"> -->
      <router-link v-if="!$auth.user" to="/sign-in" v-slot="{ href, navigate, isActive }">
        <li :class="[isActive ? 'nav-item active' : 'nav-item']">
          <div data-bs-dismiss="offcanvas" class="d-flex align-items-center">
            <a class="nav-link me-2" :href="href" @click="navigate">
              {{ $t('Sign In') }}
            </a>
            <button class="navbar-toggler navbar-toggler-right close-btn border-0 d-inline-flex d-sm-none ms-auto mb-sm-0"
              type="button" data-bs-dismiss="offcanvas" aria-label="Close"><span><i
                  class="fas fa-times"></i></span></button>
          </div>
        </li>
      </router-link>
    </div>
  </div>
  </li>
  <router-link to="/" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('Home') }}
        </a>
      </div>
    </li>
  </router-link>
  <router-link v-if="$auth.user" to="/address" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('Delivery Address') }}
        </a>
      </div>
    </li>
  </router-link>
  <router-link v-if="$auth.user && $auth.setting && $auth.setting.client_wallet_status == 'active'" to="/wallet"
    v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('My Wallet') }}
          <!-- <div class="wallet-bal"><span v-html="$auth.setting.currency" class="currency"></span>{{ mywalletAmount }}</div> -->
          <div class="wallet-bal"><span v-html="$auth.setting.currency" class="currency"></span>{{ waller_data }}</div>
        </a>
      </div>
    </li>
  </router-link>
  <router-link v-if="$auth.user" to="/orders" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('Orders') }}
        </a>
      </div>
    </li>
  </router-link>

  <router-link to="/promo-code" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('Promocode') }}
        </a>
      </div>
    </li>
  </router-link>
  <router-link to="/faq" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('FAQ') }}
        </a>
      </div>
    </li>
  </router-link>

  <router-link to="/pages" v-slot="{ href, navigate, isActive }">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']" data-bs-dismiss="offcanvas">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('Privacy & Terms') }}
        </a>
      </div>
    </li>
  </router-link>
  <router-link to="/support" v-slot="{ href, navigate, isActive }" v-if="nosupport">
    <li :class="[isActive ? 'nav-item active' : 'nav-item']">
      <div data-bs-dismiss="offcanvas">
        <a class="nav-link" :href="href" @click="navigate">
          {{ $t('Support') }}
        </a>
      </div>
    </li>
  </router-link>
  <li class="nav-item logout-nav" @click="LogOut">
    <div data-bs-dismiss="offcanvas">
      <a class="nav-link" v-if="$auth.user">{{ $t('Sign Out') }}</a>
    </div>
  </li>
  </ul>
  <div class="sidebar-footer pb-3">
    <div class="store-btns d-flex align-items-center mt-4 justify-content-center">
      <div data-bs-dismiss="offcanvas">
        <a v-if="$auth.setting && $auth.setting.ios_customer_app_url && $auth.setting.ios_customer_app_url != 'undefined' && $auth.setting.ios_customer_app_url != 'null'"
          :href="$auth.setting.ios_customer_app_url" target="_blank" class="text-center me-2">
          <img src="@/assets/images/app-store.png" />
        </a>
      </div>
      <div data-bs-dismiss="offcanvas">
        <a v-if="$auth.setting && $auth.setting.android_customer_app_url && $auth.setting.android_customer_app_url != 'undefined' && $auth.setting.android_customer_app_url != 'null'"
          :href="$auth.setting.android_customer_app_url" target="_blank" class="text-center">
          <img src="@/assets/images/google-play.png" />
        </a>
      </div>
    </div>
    <div class="sidebar-footer-logo | px-5 py-2 text-center"
      v-if="$auth && $auth.setting && $auth.setting.show_contact_developer == 'Yes'">
      <a href="https://deonde.co/">
        <svg width="140" height="50" viewBox="0 0 529 108" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M111.787 107.294V45H137.027C141.589 45 145.885 45.8306 149.914 47.4918C153.942 49.0936 157.408 51.2888 160.312 54.0772C163.274 56.8656 165.615 60.188 167.333 64.0443C169.051 67.8413 169.91 71.935 169.91 76.3252C169.91 80.597 169.051 84.6311 167.333 88.4282C165.615 92.2251 163.274 95.518 160.312 98.3064C157.408 101.095 153.942 103.29 149.914 104.892C145.885 106.493 141.589 107.294 137.027 107.294H111.787ZM136.672 58.5268H127.073V93.7678H136.672C139.101 93.7678 141.382 93.3226 143.515 92.4328C145.648 91.5429 147.484 90.3268 149.025 88.7841C150.625 87.1823 151.869 85.3135 152.757 83.1777C153.646 81.0419 154.091 78.7577 154.091 76.3252C154.091 73.8335 153.646 71.5196 152.757 69.3838C151.869 67.1887 150.625 65.2902 149.025 63.6883C147.484 62.0865 145.648 60.8406 143.515 59.9507C141.382 59.0014 139.101 58.5268 136.672 58.5268Z"
            fill="#8F8F8F" />
          <path
            d="M178.009 107.294V45H227.068V58.2598H193.295V69.4729H227.282V82.2876H193.295V94.0346H227.423V107.294H178.009Z"
            fill="#8F8F8F" />
          <path
            d="M322.633 75.3689C322.633 79.5212 321.829 83.4518 320.224 87.1614C318.617 90.8152 316.432 93.9986 313.664 96.7115C310.894 99.3688 307.601 101.473 303.781 103.023C299.961 104.573 295.892 105.348 291.573 105.348C287.255 105.348 283.186 104.573 279.366 103.023C275.546 101.473 272.251 99.3688 269.483 96.7115C266.716 93.9986 264.528 90.8152 262.923 87.1614C261.316 83.4518 260.515 79.5212 260.515 75.3689C260.515 71.2166 261.316 67.3136 262.923 63.6595C264.528 59.9502 266.716 56.7668 269.483 54.1094C272.251 51.3966 275.546 49.2651 279.366 47.7149C283.186 46.1647 287.255 45.3896 291.573 45.3896C295.892 45.3896 299.961 46.1647 303.781 47.7149C307.601 49.2651 310.894 51.3966 313.664 54.1094C316.432 56.7668 318.617 59.9502 320.224 63.6595C321.829 67.3136 322.633 71.2166 322.633 75.3689ZM307.933 75.3689C307.933 72.9882 307.518 70.7738 306.687 68.7253C305.856 66.6214 304.695 64.8222 303.199 63.3274C301.759 61.8326 300.044 60.6699 298.05 59.8395C296.058 58.9537 293.898 58.5108 291.573 58.5108C289.247 58.5108 287.089 58.9537 285.095 59.8395C283.103 60.6699 281.358 61.8326 279.864 63.3274C278.425 64.8222 277.289 66.6214 276.458 68.7253C275.629 70.7738 275.212 72.9882 275.212 75.3689C275.212 77.7496 275.629 79.9917 276.458 82.0956C277.289 84.144 278.425 85.9156 279.864 87.4105C281.358 88.9051 283.103 90.0956 285.095 90.9814C287.089 91.8118 289.247 92.2269 291.573 92.2269C293.898 92.2269 296.058 91.8118 298.05 90.9814C300.044 90.0956 301.759 88.9051 303.199 87.4105C304.695 85.9156 305.856 84.144 306.687 82.0956C307.518 79.9917 307.933 77.7496 307.933 75.3689Z"
            fill="#8F8F8F" />
          <path
            d="M330.226 46.303H343.68L370.089 80.0191V46.303H383.541V104.434H370.918L343.68 69.3895V104.434H330.226V46.303Z"
            fill="#8F8F8F" />
          <path
            d="M416.548 105.348V45.3896H440.873C445.272 45.3896 449.411 46.1891 453.294 47.788C457.178 49.3298 460.518 51.4426 463.315 54.1264C466.17 56.8103 468.426 60.0081 470.082 63.7198C471.738 67.3744 472.567 71.3146 472.567 75.5402C472.567 79.6515 471.738 83.5347 470.082 87.1892C468.426 90.8439 466.17 94.013 463.315 96.6968C460.518 99.3809 457.178 101.494 453.294 103.035C449.411 104.577 445.272 105.348 440.873 105.348H416.548ZM440.531 58.4092H431.282V92.3285H440.531C442.874 92.3285 445.072 91.9002 447.127 91.0437C449.183 90.1872 450.954 89.0165 452.438 87.5319C453.979 85.99 455.178 84.1914 456.035 82.1355C456.891 80.0799 457.321 77.8814 457.321 75.5402C457.321 73.1419 456.891 70.9149 456.035 68.8591C455.178 66.7462 453.979 64.919 452.438 63.3772C450.954 61.8354 449.183 60.6362 447.127 59.7797C445.072 58.866 442.874 58.4092 440.531 58.4092Z"
            fill="#8F8F8F" />
          <path
            d="M480.37 105.348V45.3896H527.652V58.1522H495.104V68.9447H527.503V81.279H495.104V92.5855H527.994V105.348H480.37Z"
            fill="#8F8F8F" />
          <path
            d="M248.444 74.9792C248.444 77.5595 246.353 79.6513 243.774 79.6513C241.193 79.6513 239.102 77.5595 239.102 74.9792C239.102 72.3989 241.193 70.3071 243.774 70.3071C246.353 70.3071 248.444 72.3989 248.444 74.9792Z"
            fill="#8F8F8F" />
          <path
            d="M404.569 74.9792C404.569 77.5595 402.477 79.6513 399.896 79.6513C397.315 79.6513 395.224 77.5595 395.224 74.9792C395.224 72.3989 397.315 70.3071 399.896 70.3071C402.477 70.3071 404.569 72.3989 404.569 74.9792Z"
            fill="#8F8F8F" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M2.98331 1C1.33567 1 0 2.33567 0 3.98331V55.4235L10.0475 48.3478L3.19002 44.2643C2.25951 43.7103 1.76885 42.634 1.95889 41.5639C2.14893 40.4938 2.97978 39.6547 4.04355 39.4583L41.4842 32.5482C42.3185 32.394 43.175 32.66 43.7777 33.2601C44.3804 33.86 44.6531 34.7184 44.5077 35.5583L37.8854 73.8204C37.6996 74.8945 36.868 75.7391 35.801 75.9368C34.7341 76.1347 33.6574 75.6443 33.1023 74.7075L28.4528 66.862L1.71044 107.006C2.0965 107.188 2.52798 107.29 2.98331 107.29H35.0117C64.3629 107.29 88.1568 83.4962 88.1568 54.145C88.1568 24.7939 64.3631 1 35.0117 1H2.98331ZM0 100.203L26.4258 60.5345C26.9209 59.7916 27.7602 59.3556 28.6494 59.3792C29.5386 59.4028 30.3539 59.8828 30.809 60.6508L33.9754 65.9936L38.7595 38.3512L11.7933 43.3281L16.1492 45.9218C16.9071 46.3731 17.3852 47.1803 17.4188 48.0648C17.4524 48.9496 17.0369 49.791 16.3155 50.2988L4.82221 58.3928L0 61.7888V100.203Z"
            fill="#8F8F8F" />
          <path
            d="M118.082 27V1.54545H126.683C128.68 1.54545 130.313 1.90589 131.58 2.62677C132.856 3.33937 133.801 4.30469 134.414 5.52273C135.027 6.74077 135.334 8.09967 135.334 9.59943C135.334 11.0992 135.027 12.4622 134.414 13.6886C133.809 14.9149 132.873 15.8926 131.605 16.6218C130.337 17.3427 128.713 17.7031 126.733 17.7031H120.568V14.9688H126.634C128.001 14.9688 129.099 14.7326 129.927 14.2603C130.756 13.788 131.357 13.15 131.729 12.3462C132.111 11.5342 132.301 10.6186 132.301 9.59943C132.301 8.58026 132.111 7.6688 131.729 6.86506C131.357 6.06132 130.752 5.43158 129.915 4.97585C129.078 4.51184 127.968 4.27983 126.584 4.27983H121.165V27H118.082ZM182.426 14.2727C182.426 16.9574 181.942 19.2775 180.972 21.233C180.003 23.1884 178.673 24.6965 176.983 25.7571C175.292 26.8177 173.362 27.348 171.191 27.348C169.02 27.348 167.089 26.8177 165.399 25.7571C163.708 24.6965 162.379 23.1884 161.409 21.233C160.44 19.2775 159.955 16.9574 159.955 14.2727C159.955 11.5881 160.44 9.26799 161.409 7.3125C162.379 5.35701 163.708 3.84896 165.399 2.78835C167.089 1.72775 169.02 1.19744 171.191 1.19744C173.362 1.19744 175.292 1.72775 176.983 2.78835C178.673 3.84896 180.003 5.35701 180.972 7.3125C181.942 9.26799 182.426 11.5881 182.426 14.2727ZM179.444 14.2727C179.444 12.0687 179.075 10.2085 178.337 8.69212C177.608 7.17578 176.618 6.02817 175.367 5.24929C174.124 4.47041 172.732 4.08097 171.191 4.08097C169.649 4.08097 168.253 4.47041 167.002 5.24929C165.759 6.02817 164.769 7.17578 164.032 8.69212C163.302 10.2085 162.938 12.0687 162.938 14.2727C162.938 16.4768 163.302 18.337 164.032 19.8533C164.769 21.3697 165.759 22.5173 167.002 23.2962C168.253 24.075 169.649 24.4645 171.191 24.4645C172.732 24.4645 174.124 24.075 175.367 23.2962C176.618 22.5173 177.608 21.3697 178.337 19.8533C179.075 18.337 179.444 16.4768 179.444 14.2727ZM212.883 27L205.923 1.54545H209.055L214.374 22.277H214.623L220.042 1.54545H223.522L228.941 22.277H229.19L234.509 1.54545H237.641L230.681 27H227.499L221.882 6.71591H221.683L216.065 27H212.883ZM262.132 27V1.54545H277.494V4.27983H265.214V12.8807H276.699V15.6151H265.214V24.2656H277.693V27H262.132ZM303.7 27V1.54545H312.301C314.289 1.54545 315.922 1.88518 317.198 2.56463C318.474 3.23579 319.418 4.15968 320.032 5.33629C320.645 6.5129 320.951 7.85109 320.951 9.35085C320.951 10.8506 320.645 12.1805 320.032 13.3406C319.418 14.5006 318.478 15.412 317.21 16.0749C315.943 16.7295 314.323 17.0568 312.351 17.0568H305.39V14.2727H312.251C313.61 14.2727 314.704 14.0739 315.532 13.6761C316.369 13.2784 316.974 12.715 317.347 11.9858C317.728 11.2483 317.919 10.37 317.919 9.35085C317.919 8.33168 317.728 7.44093 317.347 6.67862C316.966 5.91631 316.357 5.32801 315.52 4.91371C314.683 4.49112 313.577 4.27983 312.201 4.27983H306.782V27H303.7ZM315.682 15.5653L321.946 27H318.366L312.201 15.5653H315.682ZM346.738 27V1.54545H362.1V4.27983H349.82V12.8807H361.304V15.6151H349.82V24.2656H362.299V27H346.738ZM396.161 27H388.306V1.54545H396.509C398.978 1.54545 401.091 2.05504 402.848 3.07422C404.604 4.08511 405.951 5.5393 406.887 7.43679C407.823 9.32599 408.291 11.5881 408.291 14.223C408.291 16.8745 407.819 19.1573 406.875 21.0714C405.93 22.9772 404.554 24.4438 402.748 25.4712C400.942 26.4904 398.746 27 396.161 27ZM391.388 24.2656H395.962C398.067 24.2656 399.811 23.8596 401.194 23.0476C402.578 22.2356 403.61 21.0797 404.289 19.5799C404.969 18.0801 405.308 16.2945 405.308 14.223C405.308 12.1681 404.973 10.399 404.302 8.91584C403.631 7.42436 402.628 6.28089 401.294 5.48544C399.96 4.6817 398.299 4.27983 396.31 4.27983H391.388V24.2656ZM464.606 27V1.54545H473.505C475.278 1.54545 476.74 1.85204 477.892 2.4652C479.044 3.07007 479.902 3.88624 480.465 4.91371C481.028 5.93288 481.31 7.06392 481.31 8.30682C481.31 9.40057 481.115 10.3037 480.726 11.0163C480.345 11.7289 479.839 12.2924 479.21 12.7067C478.588 13.121 477.913 13.4276 477.184 13.6264V13.875C477.963 13.9247 478.746 14.1982 479.533 14.6953C480.32 15.1925 480.979 15.9051 481.509 16.8331C482.039 17.7611 482.305 18.8963 482.305 20.2386C482.305 21.5147 482.014 22.6623 481.434 23.6815C480.854 24.7006 479.939 25.5085 478.688 26.1051C477.436 26.7017 475.808 27 473.803 27H464.606ZM467.688 24.2656H473.803C475.817 24.2656 477.246 23.8762 478.091 23.0973C478.945 22.3101 479.371 21.3572 479.371 20.2386C479.371 19.3769 479.152 18.5814 478.713 17.8523C478.273 17.1148 477.648 16.5265 476.836 16.0874C476.024 15.6399 475.063 15.4162 473.952 15.4162H467.688V24.2656ZM467.688 12.7315H473.405C474.333 12.7315 475.17 12.5492 475.916 12.1847C476.67 11.8201 477.267 11.3063 477.706 10.6435C478.153 9.98059 478.377 9.2017 478.377 8.30682C478.377 7.18821 477.988 6.23946 477.209 5.46058C476.43 4.67341 475.195 4.27983 473.505 4.27983H467.688V12.7315ZM505.832 1.54545H509.362L516.421 13.4276H516.72L523.779 1.54545H527.309L518.112 16.5099V27H515.029V16.5099L505.832 1.54545Z"
            fill="#8F8F8F" />
        </svg>
      </a>
    </div>
  </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      menus: [],
      terms_url: null,
      privacypolicy_url: null,
      help_url: null,
      setting: null,
      is_support: false,
      email: null,
      phone: null,
      whatsapp: null,
      iswalletDisplay: false,
      mywalletAmount: 0,
      nosupport: true,
    };
  },

  computed: {
    ...mapGetters("user", ["userWallet", "getUserWallet", "walletAmount"]),
    waller_data() {
      return this.$auth.user.wallet_amount;
    }
  },

  // mounted() {
  //   setTimeout(() => {
  //     this.setting = this.$auth.setting;
  //     this.setStaticPages();
  //     if (this.$auth.user) {
  //       // this.getWalltet();
  //       // this.getuserWallet();
  //       this.mywalletAmount = this.$auth.user.wallet_amount; //(this.$auth.userWalletAmount && this.$auth.userWalletAmount != null && this.$auth.userWalletAmount != '' ? this.$auth.userWalletAmount:this.userWallet);       
  //     }
  //   }, 1000);
  // },


  mounted() {
    this.$auth.setUser();
    setTimeout(() => {
      this.setting = this.$auth.setting;
      this.setStaticPages();
      if (this.$auth.user) {
        this.getuserWallet()
        // this.mywalletAmount = this.$auth.user.wallet_amount; //(this.$auth.userWalletAmount && this.$auth.userWalletAmount != null && this.$auth.userWalletAmount != '' ? this.$auth.userWalletAmount:this.userWallet);        
        // this.mywalletAmount = this.walletAmount;
        this.mywalletAmount = this.$auth.user.wallet_amount;
      }
    }, 1000);
  },

  methods: {
    ...mapActions("user", ["checkLogout", "getuserWallet"]),

    LogOut() {
      if (confirm(this.$t("Are you sure you want to logout?"))) {
        let logoutData = {
          user_id: this.$auth.user.user_id,
          devicetype: "I",
          devicetoken: this.$auth.user.token,
          unquie_id: "",
          vendor_id: this.$auth.getVendorId(),
          is_langauge: this.$store.state.lang.locale,
        }
        this.$auth.logout(logoutData, (callback) => {
          this.$store.commit('product/clearCartItems')
          localStorage.removeItem('place_order_data');
          // const vuex = JSON.parse(localStorage.getItem('vuex'));
          // if (vuex.address) {
          //   localStorage.removeItem('vuex');
          // }
          this.$router.push({ name: callback }).catch(() => { });
        });
      }
    },

    sideMenu() {
      this.menus = [
        {
          title: "Home",
          link: "home",
          isAuthRequired: true
        },
        {
          title: "Login",
          link: "sign-in",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "Delivery Address",
          link: "address",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "Orders",
          link: "orders",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "My Profile",
          link: "profile",
          isAuthRequired: (this.$auth.user) ? true : false
        },
        {
          title: "Promocode",
          link: "promo-code",
          isAuthRequired: true
        },
        {
          title: "pages",
          link: "pages",
          isAuthRequired: true
        },
        {
          title: "FAQ",
          link: "faq",
          isAuthRequired: true
        },
        {
          title: "PrivacyPolicy",
          link: "privacypolicy",
          isAuthRequired: true
        },
      ];
    },

    setStaticPages() {
      if (this.setting) {
        if (this.setting.pages && this.setting.pages.length > 0) {
          for (let index = 0; index < this.setting.pages.length; index++) {
            if (this.setting.pages[index].privacypolicy_url) {
              this.privacypolicy_url = this.setting.pages[index].privacypolicy_url;
            } else if (this.setting.pages[index].help_url) {
              this.help_url = this.setting.pages[index].help_url;
            } else if (this.setting.pages[index].terms_url) {
              this.terms_url = this.setting.pages[index].terms_url;
            }
          }
        }
        if (this.setting.support_field && this.setting.support_field.length > 0) {
          if (this.setting.support_field[0]) {
            if (this.setting.support_field[0].phone || this.setting.support_field[0].whatsapp || this.setting.support_field[0].email) {
              this.is_support = true;
            }
            if (this.setting.support_field && !this.setting.support_field[0].phone && !this.setting.support_field[0].whatsapp && !this.setting.support_field[0].email) {
              this.nosupport = false;
            }
          }

        }
      }
    }
  },
};

</script>